





































































import { Vue, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { HeaderInfo } from '@/core/admin/models/UserDataTable';
import { CmsCredentialData } from '@/core/admin/models/CmsCredential';
import CmsCredentialDialog from '@/ui/components/organisms/dialogs/CmsCredentialDialog.vue';
import { Loader } from '@/ui/util/decorators/loader';
import { AdminStoreMutations } from '@/ui/stores/AdminStore';
import DeleteCmsCredentialDialog from '@/ui/components/organisms/dialogs/DeleteCmsCredentialDialog.vue';

@Component({
  name: 'admin-cms-credentials-table',
  components: { DeleteCmsCredentialDialog, CmsCredentialDialog },
})
export default class AdminCmsCredentialsTable extends Vue {
  private selectedCmsCredential: CmsCredentialData = this.getEmptyCmsCredential();
  private showEditCmsCredentialDialog = false;
  private showDeleteCmsCredentialDialog = false;

  page = 1;
  pageCount = 0;

  mounted() {
    this.$store.dispatch('adminStore/getAllCmsCredentials');
  }

  get currentUser() {
    return this.$store.state.userStore.currentUser;
  }

  get headers(): Array<HeaderInfo> {
    return [
      { text: 'Customer Name', value: 'customer.name' },
      { text: 'Customer ID', value: 'customerId' },
      { text: 'CMS Username', value: 'cmsUsername' },
      { text: 'Group ID', value: 'cmsGroupId' },
      { text: '', value: 'actions' },
    ];
  }

  @Loader
  async refreshTable() {
    await this.$store.dispatch('adminStore/getAllCmsCredentials');
  }

  get isNewCmsCredentialCreated() {
    return this.$store.state.adminStore.isNewCmsCredentialCreated;
  }

  @Watch('isNewCmsCredentialCreated')
  oneNewCredential(val: boolean) {
    if (val) {
      this.$store.commit(AdminStoreMutations.SET_IS_NEW_CMS_CREDENTIALS_CREATED, false);
      this.refreshTable();
    }
  }

  get cmsCredentials(): Array<CmsCredentialData> {
    return this.$store.state.adminStore.cmsCredentials;
  }

  onEditCmsCredential(cmsCredential: CmsCredentialData) {
    this.selectedCmsCredential = cmsCredential;
    this.showEditCmsCredentialDialog = true;
  }

  onDeleteCmsCredential(cmsCredential: CmsCredentialData) {
    this.selectedCmsCredential = cmsCredential;
    this.showDeleteCmsCredentialDialog = true;
  }

  closeEditCmsCredentialDialog() {
    this.showEditCmsCredentialDialog = false;
  }

  closeDeleteCmsCredentialDialog() {
    this.showDeleteCmsCredentialDialog = false;
  }

  getEmptyCmsCredential() {
    return {
      customerId: '',
      cmsUsername: '',
      cmsGroupId: '',
      customer: {
        id: '',
        name: '',
        shortName: '',
        isActive: true,
      },
    };
  }
}
